<template>
    <div class="btn" :class="classes" @click.stop="click">
        <slot/>
    </div>
</template>

<script>
export default {
    name: "btn",
    props: {
        icon: Boolean,
        iconRight: Boolean,
        square: Boolean,
        active: Boolean,
        color: String,
        disabled: Boolean,
        link: Boolean,
        small: Boolean,
        light: Boolean,
        dark: Boolean,
        item: Boolean,
        noBorder: Boolean,
        border: Boolean,
        noInteraction: Boolean,
        remove: Boolean,
    },
    methods: {
        click() {
            if (this.disabled) return;
            
            this.$emit('click');
        }
    },
    computed: {
        classes() {
            return [
                {
                    square: this.square,
                    link: this.link,
                    small: this.small,
                    active: this.active,
                    disabled: this.disabled,
                    icon: this.icon,
                    'icon-right': this.iconRight,
                    light: this.light,
                    dark: this.dark,
                    item: this.item,
                    'no-border': this.noBorder,
                    border: this.border,
                    'no-interaction':this.noInteraction,
                    remove:this.remove,
                },
                this.color
            ]
        }
    }
}
</script>